import { render, staticRenderFns } from "./AlternateValuesChipEditor.vue?vue&type=template&id=04729287&scoped=true&"
import script from "./AlternateValuesChipEditor.vue?vue&type=script&lang=js&"
export * from "./AlternateValuesChipEditor.vue?vue&type=script&lang=js&"
import style0 from "./AlternateValuesChipEditor.vue?vue&type=style&index=0&id=04729287&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04729287",
  null
  
)

export default component.exports